import React, { createContext, useContext, useState, useMemo, useCallback } from "react";

export interface RouteDto {
  Icon: any;
  navId: string | null;
  navItem: string | null;
  navPath: string | null;
}

export interface UIContextType {
  isInvitation: boolean;
  setIsInvitation: (val: boolean) => void;
  routeDto: RouteDto;
  setRouteDto: (val: RouteDto) => void;
  accountDashboardVersion: number;
  notifyAccountDashboardRefresh: () => void;
}

const UIContext = createContext<UIContextType | undefined>(undefined);

export const useUIContext = () => {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error("useUIContext must be used inside UIProvider");
  return ctx;
};

export const UIProvider = ({ children }: { children: React.ReactNode }) => {
  const [isInvitation, setIsInvitation] = useState(false);
  const [routeDto, setRouteDto] = useState<RouteDto>({
    Icon: null,
    navId: null,
    navItem: null,
    navPath: null,
  });

  const [accountDashboardVersion, setAccountDashboardVersion] = useState(0);

  const notifyAccountDashboardRefresh = useCallback(() => {
    setAccountDashboardVersion((version) => version + 1);
  }, []);

  const value = useMemo(
    () => ({
      isInvitation,
      setIsInvitation,
      routeDto,
      setRouteDto,
      accountDashboardVersion,
      notifyAccountDashboardRefresh,
    }),
    [isInvitation, routeDto, accountDashboardVersion, notifyAccountDashboardRefresh]
  );

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};
